import { Col, Row } from "react-bootstrap";
import type { PkClans } from "../../../types/playerPk";
import { formatEtMonthYear } from "../../../utils/etDate";
import RankedBars from "./RankedBars";
import "../../epicLeaderboard/epicLeaderboard.css";
import "./pk.css";

type Props = {
  clans: PkClans;
};

const span = (first: string, last: string): string => {
  const a = formatEtMonthYear(first);
  const b = formatEtMonthYear(last);
  return a === b ? a : `${a} - ${b}`;
};

const ClansSection = ({ clans }: Props) => (
  <Row className="g-3">
    <Col xs={12} lg={6}>
      <div className="pk-card">
        <div className="pk-subtitle">Clan history</div>
        {clans.history.length === 0 ? (
          <div className="epic-lb-muted">No clan recorded in this range.</div>
        ) : (
          <ol className="pk-timeline">
            {clans.history.map((entry, i) => (
              <li key={`${entry.clan}-${entry.firstEt}-${i}`}>
                <div className="pk-wrap-anywhere">
                  <strong>{entry.clan || "No clan"}</strong>
                </div>
                <div className="epic-lb-muted">
                  {span(entry.firstEt, entry.lastEt)} - {entry.kills} kills,{" "}
                  {entry.deaths} deaths
                </div>
              </li>
            ))}
          </ol>
        )}
      </div>
    </Col>
    <Col xs={12} md={6} lg={3}>
      <div className="pk-card">
        <div className="pk-subtitle">Most killed clans</div>
        <RankedBars
          items={clans.killsAgainst.map((c) => ({
            label: c.clan || "No clan",
            count: c.count
          }))}
          emptyText="No kills in this range."
        />
      </div>
    </Col>
    <Col xs={12} md={6} lg={3}>
      <div className="pk-card">
        <div className="pk-subtitle">Died to clans</div>
        <RankedBars
          items={clans.deathsTo.map((c) => ({
            label: c.clan || "No clan",
            count: c.count
          }))}
          color="rgb(255, 99, 132)"
          emptyText="No deaths in this range."
        />
      </div>
    </Col>
  </Row>
);

export default ClansSection;
